<template>
  <div>
    <md-card id="reports" align="Left">
      <md-card-header class="md-card-header-icon md-card-header-green">
        <div class="card-icon"><i class="fas fa-2x fa-user-md"/></div>        <h4 class="title">Doctors List</h4>

        <div class="md-layout md-gutter md-layout-item md-size-100 md-alignment-center-left" style="padding: 0; justify-content: flex-start;">
          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm"><label>Search</label>
              <md-input v-model="currentSearchTxt"/>
            </md-field>
          </div>

          <div class="md-layout md-gutter md-layout-item md-size-20">
            <md-field class="md-sm"><label>Address</label>
              <md-input v-model="currentAddressTxt"/>
            </md-field>
          </div>


          <div class="md-layout-item md-size-20">
            <md-field>
              <label for="currentType">Qualification</label>
              <md-select v-model="currentQualificationTxt" name="currentFilterDate">
                <md-option :value="''">All</md-option>
                <md-option v-for="(opt, index) in filterQualificationOptions" :key="index" :value="opt">
                  {{ opt }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item md-size-20" v-if="organizations.length > 2">
            <md-field>
              <label for="currentType">Organization</label>
              <md-select v-model="currentOrganization" name="organization">
                <md-option v-for="(type, index) in organizations" :key="index" :value="type.value">
                  {{ type.label }}
                </md-option>
              </md-select>
            </md-field>
          </div>

          <div class="md-layout-item" style="align-items: end;" :class="[
            { 'md-size-20': organizations.length > 2 },
            { 'md-size-40': organizations.length <= 2 }
          ]">
            <div class="md-layout md-gutter md-layout-item"
                style="display: flex; align-items: center; justify-content: right">
              <md-button class="md-icon-button md-primary" @click="handleSearch">
                <md-icon>search</md-icon>
                <md-tooltip md-direction="bottom">Filter</md-tooltip>
              </md-button>
            </div>
          </div>
        </div>
      </md-card-header>

      <md-card-content>
        <md-table id="reports-table" v-if="!isLoading" v-model="tableData"
                  class="table-shopping table-striped table-hover" @click.native="labelSort($event, false)">
          <md-table-row>
            <md-table-empty-state :md-description="`No doctors found for this time frame or search criteria`"
                                  md-label="No doctors found"/>
          </md-table-row>
          <md-table-row
              slot="md-table-row"
              slot-scope="{ item }"
              :key="item.expr1"
              @click="openInfoModal(item)">
            <md-table-cell style="height: 55px;width: 26px;"/>
            <md-table-cell md-label="Name" style="font-size: 1.13em">
              {{ item.FullName }}, {{ item.Title }}
              <br/>
              <small>{{ item.Practice }}</small>
            </md-table-cell>
            <md-table-cell md-label="Email" class="change-color" style="font-size: 0.95em; color: blue"><a :href="'mailto:' + item.Email">{{ item.Email || '-' }}</a></md-table-cell>
            <md-table-cell md-label="Phone">{{ item.Phone || '-' }}</md-table-cell>
            <md-table-cell md-label="Qualification">{{ item.Qualification || '-' }}</md-table-cell>
            <md-table-cell md-label="City">{{ item.City || '-' }}</md-table-cell>
            <md-table-cell md-label="Address">{{ item.Address || '-' }}</md-table-cell>
            <md-table-cell md-label="State">{{ item.State || '-' }}</md-table-cell>
            <md-table-cell md-label="Zip">{{ item.Zip || '-' }}</md-table-cell>
            <md-table-cell/>
          </md-table-row>
        </md-table>

        <hr v-if="!isLoading"/>
        <div v-if="!isLoading" style="display: flex;align-items: center;">
          <div class="pagination-container" style="flex: 1; justify-content: start; height: 50%">
            <a :disabled="offset === 0" class="page-link" style="color: #999" aria-label="Previous" @click="prevPage">
              <i class="fas fa-angle-double-left"/>
            </a>
            <span class="page-link"
                  style="background-color: #4caf50; color: white; padding: 5px 10px; border-radius: 16px;">{{
                currentPage
              }}</span>
            <a class="page-link" aria-label="Next" style="color: #999" @click="nextPage">
              <i class="fas fa-angle-double-right"/>
            </a>
          </div>
          <div class="table table-stats" style="display: flex; justify-content:center; align-items:start; flex: 2">
            <div class="text-right">
              <p class="card-category">
                Showing from <b><u>{{ firstPageItemCount }}</u></b>to <b><u>{{ lastPageItemCount }}</u></b>.
                Total of <b><u>{{ totalItems }}</u></b> doctors.
              </p>
            </div>
          </div>
          <md-field style="flex: 1; margin-top: 1.5rem">
            <label for="pages">Per page</label>
            <md-select v-model="pagination.perPage" name="pages" @change="updateLimit">
              <md-option v-for="item in pagination.perPageOptions" :key="item" :value="item">
                {{ item }}
              </md-option>
            </md-select>
          </md-field>
        </div>
      </md-card-content>
    </md-card>
    <DoctorDetailsModal
      :modelValue="showInfoModal"
      :doctor="selectedDoctor"
      @update:modelValue="showInfoModal = $event"
    />

    <loader :is-visible="isLoading"/>
  </div>
</template>

<script>
import Swal from "sweetalert2"
import loader from "@/components/GlobeChek/loader.vue"
import DoctorDetailsModal from '@/components/modals/DoctorDetailsModal.vue';

export default {
  components: {
    loader,
    DoctorDetailsModal
  },
  data() {
    return {
      API_SERVICE: process.env.VUE_APP_URL,
      API_ROUTE: "/dractive/null/null",
      allData: [],
      filteredData: [],
      tableData: [],
      selectedItems: [],
      allSelected: false,
      currentSort: "name",
      currentSortOrder: "asc",
      orderAsc: false,
      searchQuery: "",
      fuseSearch: null,
      offset: 0,
      limit: 50,
      totalItems: 0,
      pagination: {
        perPage: 50,
        perPageOptions: [10, 20, 50, 100, 200]
      },
      isLoading: false,
      currentSearchTxt: "",
      currentQualificationTxt: "",
      currentAddressTxt: "",
      filterQualificationOptions: [],
      showInfoModal: false,
      selectedDoctor: null,
      currentOrganization: JSON.parse(sessionStorage.getItem("organizations")).length === 1 ? JSON.parse(sessionStorage.getItem("organizations"))[0].orgId : (localStorage.getItem("currentOrgSelectedForFilters") || "all"),
      organizations: [
        { label: 'All', value: 'all' },
        ...JSON.parse(sessionStorage.getItem('organizations')).map(i => {
          return {
            label: i.orgName,
            value: i.orgId
          }
        }),
      ],
    }
  },
  computed: {
    // Returns a page from the searched data or the whole data. Search is performed in the watch section below
    currentPage() {
      return Math.floor(this.offset / this.limit) + 1
    },
    hasMoreData() {
      return this.offset + this.limit < this.filteredData.length
    },
    firstPageItemCount() {
      return this.offset + 1;
    },
    lastPageItemCount() {
      return Math.min(this.offset + this.limit, this.filteredData.length) || 1;
    },
  },
  watch: {
    "pagination.perPage"(newLimit) {
      this.limit = newLimit;
      this.offset = 0;
      this.sliceData();
    },
    currentOrganization(newVal) {
      localStorage.setItem('currentOrgSelectedForFilters', newVal);
      this.fetchReports();
    }
  },

  mounted() {
    this.fetchReports();
  },

  methods: {
    async fetchReports() {
      this.isLoading = true;
      const params = {};
      if (this.currentOrganization && this.currentOrganization !== 'all') {
        params.orgid = this.currentOrganization;
      }
      const url = (this.API_SERVICE + this.API_ROUTE);
      const config = {
        headers: { "Content-Type": "application/json" },
        params
      };

      window.axios
          .get(url, config)
          .then(r => r.data)
          .then(data => {
            // remove duplicated reports
            const qualificationsMap = new Map()
        if (data.items) {
              data.items.forEach((data) => {
                const qualification = data.Qualification;
                if (!qualificationsMap.has(qualification)) {
                  qualificationsMap.set(qualification, qualification)
            }
          });
        }
            data.items.sort((a,b)=>a.FullName > b.FullName ? 1 : -1)
        this.allData = data.items;
            this.filterQualificationOptions = Array.from(qualificationsMap.values())
        this.handleSearch();
          })
          .catch(function (error) {
            console.error(error)
          }).finally(() => {
        this.isLoading = false
      });
    },
    sliceData() {
      this.tableData = JSON.parse(JSON.stringify(this.filteredData)).slice(this.offset, this.offset + this.limit)
    },
    updateLimit(newLimit) {
      this.offset = 0;
      this.sliceData();
    },
    prevPage() {
      if (this.offset > 0) {
        this.offset -= this.limit
        this.sliceData();
      }
    },
    nextPage() {
      if (this.hasMoreData) {
        this.offset += this.limit
        this.sliceData();
      }
    },
    labelSort(type, menu) {
      let sort = menu ? type : event.target.textContent.trim()
      this.orderAsc = !this.orderAsc
      switch (sort) {
        case "Name":
          this.sortByProperty('FullName', this.orderAsc);
          break;

        case "Email":
          this.sortByProperty('Email', this.orderAsc);
          break;

        case "Phone":
          this.sortByProperty('Phone', this.orderAsc);
          break;

        case "Qualification":
          this.sortByProperty('Qualification', this.orderAsc);
          break;

        case "City":
          this.sortByProperty('City', this.orderAsc);
          break;

        case "Address":
          this.sortByProperty('Address', this.orderAsc);
          break;

        case "State":
          this.sortByProperty('State', this.orderAsc);
          break;

        case "Zip":
          this.sortByProperty('Zip', this.orderAsc);
          break;

        default:
          return null;
      }
    },
    sortByProperty(property, order) {
      this.tableData = this.filteredData.sort(function (a, b) {
        if (order) {
          return a[property] > b[property] ? 1 : -1
        } else {
          return a[property] < b[property] ? 1 : -1
        }
      }).slice(this.offset, this.offset + this.limit);
    },

    handleSearch() {
      this.selectedItems = [];
      this.allSelected = [];
      const searchFilter = this.currentSearchTxt;
      const addressFilter = this.currentAddressTxt;
      const qualificationFilter = this.currentQualificationTxt;
      localStorage.setItem("currentOrgSelectedForFilters", this.currentOrganization)
    
      let response = JSON.parse(JSON.stringify(this.allData));
      if (searchFilter) {
        response = response.filter(i => {
          const searchText = ((i.FullName || '') + ' ' + (i.Email || '') + (i.City || '')).toLowerCase();
          return searchText.includes(searchFilter.toLowerCase());
        });
      }
      if (addressFilter) {
        response = response.filter(i => {
          const searchText = ((i.Country || '') + (i.Address || '') + (i.Latitude || '') + (i.Longitude || '') + (i.City || '')).toLowerCase();
          return searchText.includes(addressFilter.toLowerCase());
        });
      }
    
      if (qualificationFilter) {
        response = response.filter(i => {
          const searchText = ((i.Qualification || '')).toLowerCase();
          return searchText.includes(qualificationFilter.toLowerCase());
        });
      }
    
      this.filteredData = response;
      this.totalItems = response.length;
      this.offset = 0;
      this.sliceData();
    },
    openInfoModal(doctor) {
      this.selectedDoctor = doctor;
      this.showInfoModal = true;
    }

  }
}
</script>

<style lang="scss" scoped>
.md-table {
  max-height: 67dvh;
  overflow: auto;

  tr {
    cursor: pointer;
  }
}

.md-table-cell {
  font-size: 0.85rem;
  height: 38px;
}

.md-table-row {
  color: rgb(0, 6, 97);
}

.md-table-row:hover {
  background-color: #0077ff !important;
  color: white !important;

  .change-color {
    a {
      color: white !important;
    }
  }
}

.table-striped {
  tbody > tr:nth-of-type(odd) {
    background-color: #edf2f7;
  }

  tbody > tr:nth-of-type(even) {
    background-color: #ffffff;
  }
}

.md-table-head {
  cursor: pointer;
}

.md-table-row.md-selected-single {
  font-weight: 400;
  font-size: 0.95rem;
  color: white;
  background-color: #00418b !important;
}

// .md-icon {
//   margin-left: 24px !important;
// }

#headers {
  transition: none;
  background-color: #edf2f7 !important;
}

.dropdown-menu {
  li {
    padding: 3px 3px 3px 5px;
  }

  li:hover {
    background-color: #005ac2 !important;
    color: #fff !important;
  }
}

.isRead {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
}

.isEDIT {
  color: rgb(2, 171, 16);
  font-weight: 500;
  font-size: 0.87rem;
  background-color: #e6ffe6 !important;
}

.md-table-row.isEDIT:hover {
  background-color: #ccffcc !important;
  color: #000000 !important;
}

.md-button.md-grey {
  background-color: #d3d3d3 !important;
  color: #808080 !important;
}

.pagination-container {
  display: flex;
  justify-content: center;
  align-items: center;
}

.pagination-container span {
  margin: 0 15px;
}

#doctor_info_modal {
  .md-table {
    height: max-content;
    max-height: 80vh;
  }
}

</style>
